import { useLocation } from "react-router-dom";
import { ThemeToggle } from "@/components/ThemeToggle";

/**
 * Floating theme toggle shared across all public site pages.
 * Hidden on admin / member / auth surfaces, which provide their own toggle.
 */
const HIDDEN_PREFIXES = ["/admin", "/espace-membre", "/auth", "/challenge"];

export function PublicThemeToggle() {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return null;
  }
  return (
    <div className="fixed top-4 right-4 z-50">
      <ThemeToggle className="bg-background/70 border-border/60 shadow-sm" />
    </div>
  );
}
